import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TimelineIcon from "@mui/icons-material/Timeline";
import CardTable from "../../components/CardTable/CardTable";
import { TableInputs } from "../../components/CardTable/TableInputs";
import { validateObject } from "../../helpers/validateObject";
import { useSearch } from "../../hooks/useSearch";
import { useValidateReload } from "../../hooks/useValidateReload";
import {
  handleInventoryDigitalMovementsInputsAction,
  getInventoryDigitalMovementsAction,
} from "../../redux/actions/inventoryDigitalMovements/inventoryDigitalMovementsActions";
import { columns } from "./columns";

const tableKey = "inventoryDigitalMovements";
const loadings = [
  "loadingInventoryDigitalMovements",
  "loadingInventoryDigitalMovementsActions",
];

export const InventoryDigitalMovementsView = () => {
  const dispatch = useDispatch();

  const { digitalMovements, station, date } = useSelector(
    ({ inventoriesDigitalMovements }) => inventoriesDigitalMovements
  );
  const { buildTableConfig, setSnackbar } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);

  useValidateReload(loadings);

  const submit = () => {
    if (validateObject(station, true))
      return setSnackbar("Estación requerida", "warning");
    dispatch(getInventoryDigitalMovementsAction(station.id, date));
  };

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  return (
    <>
      <CardTable
        data={digitalMovements}
        columns={columns}
        hasHeader
        blockBtn
        title="Movimientos de Inventario Digital"
        icon={<TimelineIcon />}
        isLoading={isLoadingComp?.loadingInventoryDigitalMovements}
        tableContent={
          <TableInputs
            reducer="inventoriesDigitalMovements"
            date
            stations
            dispatchAction={handleInventoryDigitalMovementsInputsAction}
            preventEvent
            submitAction={submit}
          />
        }
        tableKey={tableKey}
      />
    </>
  );
};
